import {useLayoutEffect, useState} from 'react'
import Hammer from 'hammerjs'
import {isMobileHook} from './isMobileHook'
import {isInViewPortHook} from './isInViewPortHook'

export function useHammerTimeHook(
	itemsContainerId,
	itemsContainerOuterId,
	mobileBreakPoint,
	hideMarginLeft
) {
	const isMobile = isMobileHook(mobileBreakPoint)

	// const isInViewPort = isInViewPortHook(itemsContainerId, false)

	const [animationCompleted, setAnimationCompleted] = useState(false)
	let interval = null

	const frame = () => {
		const items = document.getElementById(itemsContainerId)
		let marginLeft = parseInt(items.style.marginLeft.replace('px', ''))
		if (marginLeft >= 0) {
			clearInterval(interval)
			setAnimationCompleted(true)
		} else {
			marginLeft = marginLeft + 6
			items.style.marginLeft = marginLeft + 'px'
		}
	}

	useLayoutEffect(() => {
		const items = document.getElementById(itemsContainerId)
		const itemsOuter = document.getElementById(itemsContainerOuterId)
		if (!items || !itemsOuter) {
			return;
		}

		if (itemsOuter.clientWidth - window.innerWidth > 0 && !isMobile) {
			if (!animationCompleted) {
				items.style.cursor = 'pointer';
				if (hideMarginLeft !== true) {
					items.style.marginLeft = `-${
						itemsOuter.clientWidth - window.innerWidth
					}px`;
				}
				// if (isInViewPort) {
				// 	interval = setInterval(frame, 1)
				// }
			}
		} else {
			items.style.cursor = 'initial'
			items.style.marginLeft = `auto`
		}

		// by default, it only adds horizontal recognizers
		// create a simple instance
		var mc = new Hammer(items)

		// listen to events...
		let currentMargin = 0
		let hiddenWidth = 0
		mc.on('panleft panright hammer.input', function(ev) {
			if (isMobile) {
				return
			}

			hiddenWidth = itemsOuter.clientWidth - window.innerWidth
			if (hiddenWidth <= 0) {
				return
			}

			if (ev.eventType === Hammer.INPUT_START) {
				currentMargin = parseInt(items.style.marginLeft.replace('px', ''))
				if (isNaN(currentMargin)) {
					currentMargin = 0
				}
			} else {
				if (ev.type === 'panleft' || ev.type === 'panright') {
					if (Math.abs(ev.deltaY) < 100) {
						if (
							Math.abs(currentMargin + ev.deltaX) <= hiddenWidth &&
							currentMargin + ev.deltaX < 0
						) {
							items.style.marginLeft = currentMargin + ev.deltaX + 'px'
						}
					}
				}
			}
		})
	}, [isMobile])
	// }, [isMobile, isInViewPort])
}
